export const caseStudies = [
  {
    id: 1,
    slug: 'medicare-patient-platform',
    title: 'How MediCare+ Built a Telemedicine Platform Serving 100K+ Patients',
    client: 'MediCare Health',
    industry: 'Healthcare',
    service: 'website-development',
    duration: '6 Months',
    team: '12 Members',
    image: 'https://readdy.ai/api/search-image?query=Modern%20telemedicine%20platform%20on%20multiple%20devices%20showing%20video%20consultation%20interface%2C%20medical%20dashboard%20with%20patient%20data%2C%20clean%20healthcare%20UI%20design%20with%20teal%20and%20white%20colors%2C%20professional%20medical%20tech%20environment%2C%20warm%20ambient%20lighting%2C%20high%20detail%20mockup&width=1200&height=700&seq=cs-medicare&orientation=landscape',
    challenge: 'MediCare Health operated 15 clinics across Mumbai but had no centralized patient management. Patients waited 45+ minutes for appointments, records were paper-based, and follow-ups frequently fell through cracks. They needed a HIPAA-compliant platform integrating telemedicine, EHR, and AI diagnostics.',
    approach: 'We started with a 2-week discovery sprint, shadowing doctors and staff across 3 clinics. This revealed critical workflows no one had documented. We designed a microservices architecture with React frontend, Node.js backend, and PostgreSQL — chosen for real-time performance and healthcare compliance. WebRTC was integrated for video consultations with end-to-end encryption.',
    solution: [
      'Patient portal with appointment booking, e-prescriptions, and lab reports',
      'Telemedicine module with HD video, screen sharing, and AI note-taking',
      'EHR system with FHIR-compliant APIs for interoperability',
      'AI diagnosis assistant trained on 500K+ medical records (95% accuracy)',
      'Admin dashboard with real-time analytics and resource scheduling',
      'HIPAA-compliant hosting on AWS with automated backups',
    ],
    results: [
      { value: '40%', label: 'Patient Engagement Increase' },
      { value: '60%', label: 'Administrative Workload Reduction' },
      { value: '12 mins', label: 'Average Wait Time (down from 45)' },
      { value: '100K+', label: 'Active Patients' },
      { value: '4.8/5', label: 'Patient Satisfaction Score' },
    ],
    testimonial: {
      quote: 'This platform didn\'t just digitize our operations — it fundamentally changed how we deliver healthcare. Our doctors now spend 60% more time with patients instead of paperwork.',
      name: 'Dr. Rajesh Mehta',
      role: 'CEO, MediCare Health',
    },
    techStack: ['React', 'Node.js', 'PostgreSQL', 'WebRTC', 'AWS', 'TensorFlow', 'FHIR'],
    tags: ['Telemedicine', 'EHR', 'AI/ML', 'Healthcare'],
  },
  {
    id: 2,
    slug: 'shopnow-ecommerce-scale',
    title: 'Scaling ShopNow from 500 to 10,000 Products Without Losing Performance',
    client: 'ShopNow Retail',
    industry: 'E-Commerce',
    service: 'website-development',
    duration: '8 Months',
    team: '15 Members',
    image: 'https://readdy.ai/api/search-image?query=Ecommerce%20platform%20dashboard%20on%20large%20screen%20showing%20product%20management%20and%20sales%20analytics%2C%20modern%20retail%20UI%20with%20warm%20orange%20accents%2C%20fashion%20and%20electronics%20products%20displayed%2C%20bright%20contemporary%20office%2C%20high%20detail%20business%20photography&width=1200&height=700&seq=cs-shopnow&orientation=landscape',
    challenge: 'ShopNow started as a small fashion retailer with 500 products on a WooCommerce site. As they expanded into electronics, home goods, and beauty — the site crashed during flash sales, search took 3+ seconds, and the checkout abandonment rate hit 72%. They needed a platform that could scale to 10K+ products across multiple vendors.',
    approach: 'We rebuilt the entire platform on Next.js with server-side rendering for SEO, integrated Elasticsearch for sub-100ms product search, and implemented a Redis caching layer. The checkout flow was redesigned from 5 steps to 2 steps. Stripe Connect handled multi-vendor payments seamlessly.',
    solution: [
      'Next.js e-commerce frontend with SSR and ISR for product pages',
      'Elasticsearch-powered search with faceted filtering and autocomplete',
      'Redis caching layer reducing database queries by 80%',
      'Multi-vendor architecture with separate dashboards',
      'AI recommendation engine using collaborative filtering',
      'Stripe Connect for split payments across vendors',
      'Real-time inventory sync across 3 warehouses',
    ],
    results: [
      { value: '3x', label: 'Revenue Growth in 6 Months' },
      { value: '250ms', label: 'Page Load Time' },
      { value: '99.9%', label: 'Uptime Achieved' },
      { value: '35%', label: 'Checkout Abandonment Reduction' },
      { value: '10K+', label: 'Active Products' },
    ],
    testimonial: {
      quote: 'Black Friday used to be our worst nightmare — servers crashing, angry customers. This year we processed 5x our normal volume without a single hiccup. The team absolutely nailed it.',
      name: 'Priya Sharma',
      role: 'CTO, ShopNow Retail',
    },
    techStack: ['Next.js', 'Node.js', 'MongoDB', 'Redis', 'Elasticsearch', 'Stripe', 'AWS'],
    tags: ['E-Commerce', 'Performance', 'Multi-Vendor', 'Scale'],
  },
  {
    id: 3,
    slug: 'logichain-erp-transformation',
    title: 'How LogiChain ERP Cut Delivery Times by 50% for a 2,000-Vehicle Fleet',
    client: 'TransGlobal Logistics',
    industry: 'Logistics',
    service: 'erp-solutions',
    duration: '10 Months',
    team: '18 Members',
    image: 'https://readdy.ai/api/search-image?query=Logistics%20ERP%20dashboard%20on%20ultrawide%20monitor%20showing%20fleet%20tracking%20map%20and%20supply%20chain%20analytics%2C%20dark%20blue%20and%20orange%20theme%2C%20shipping%20containers%20visible%20through%20office%20window%2C%20industrial%20corporate%20setting%2C%20high%20detail%20professional%20photography&width=1200&height=700&seq=cs-logichain&orientation=landscape',
    challenge: 'TransGlobal managed 2,000+ vehicles across India but relied on spreadsheets and phone calls for fleet management. Route planning was manual, fuel costs were uncontrolled, and customers had zero visibility into shipment status. Delivery delays cost them ₹2Cr+ annually in penalties.',
    approach: 'We built a comprehensive ERP with Laravel backend and Vue.js frontend, integrating GPS tracking for real-time fleet visibility. A custom route optimization algorithm reduced empty miles by 40%. The warehouse module automated inventory with barcode scanning, and a customer portal provided live shipment tracking.',
    solution: [
      'Fleet management with real-time GPS tracking for 2,000+ vehicles',
      'AI-powered route optimization reducing fuel costs by 28%',
      'Warehouse automation with barcode scanning and pick-path optimization',
      'Customer portal with live shipment tracking and ETA predictions',
      'Predictive maintenance alerts preventing 85% of breakdowns',
      'Integrated billing module with automated invoice generation',
      'Mobile app for drivers with digital proof of delivery',
    ],
    results: [
      { value: '50%', label: 'Faster Delivery Times' },
      { value: '30%', label: 'Operational Cost Reduction' },
      { value: '40%', label: 'Fewer Empty Miles' },
      { value: '₹2Cr+', label: 'Annual Penalty Savings' },
      { value: '95%', label: 'On-Time Delivery Rate' },
    ],
    testimonial: {
      quote: 'The visibility this ERP gives us is incredible. We can track every vehicle, every shipment, every rupee in real-time. The 30% cost reduction alone paid for the project within 8 months.',
      name: 'Anita Desai',
      role: 'Operations Director, TransGlobal Logistics',
    },
    techStack: ['Laravel', 'Vue.js', 'PostgreSQL', 'Docker', 'AWS', 'WebSocket', 'Redis'],
    tags: ['ERP', 'Logistics', 'Fleet Management', 'Route Optimization'],
  },
  {
    id: 4,
    slug: 'brandvista-ai-marketing',
    title: 'How BrandVista Achieved 200% ROI with AI-Powered Marketing Automation',
    client: 'BrandVista Agency',
    industry: 'Marketing',
    service: 'ai-automation',
    duration: '5 Months',
    team: '8 Members',
    image: 'https://readdy.ai/api/search-image?query=AI%20marketing%20dashboard%20on%20modern%20screen%20showing%20colorful%20campaign%20analytics%20charts%20and%20content%20generation%20interface%2C%20creative%20agency%20workspace%20with%20mood%20boards%2C%20warm%20vibrant%20lighting%2C%20high%20energy%20atmosphere%2C%20high%20detail%20modern%20photography&width=1200&height=700&seq=cs-brandvista&orientation=landscape',
    challenge: 'BrandVista managed social media for 40+ clients with a team of 15 content writers. Creating personalized content for each client was slow and inconsistent. Campaign optimization was reactive — they\'d notice poor performance after spending budget. They needed AI to scale content creation and automate campaign optimization.',
    approach: 'We integrated OpenAI\'s GPT-4 and DALL-E for content generation, built a custom A/B testing engine that automatically reallocates budget to winning variants, and created a customer segmentation system using clustering algorithms. The entire system was orchestrated through a FastAPI backend with React dashboard.',
    solution: [
      'AI content generator producing 500+ unique posts per day across clients',
      'Automated A/B testing engine with real-time budget reallocation',
      'Customer segmentation using K-means clustering on behavior data',
      'Sentiment analysis monitoring brand mentions across platforms',
      'Competitive intelligence dashboards tracking 200+ competitor accounts',
      'Automated reporting with AI-generated insights and recommendations',
    ],
    results: [
      { value: '200%', label: 'ROI Improvement' },
      { value: '10x', label: 'Content Output Speed' },
      { value: '68%', label: 'Engagement Rate Increase' },
      { value: '40+', label: 'Active Client Accounts' },
      { value: '₹15L', label: 'Monthly Ad Spend Managed' },
    ],
    testimonial: {
      quote: 'We went from 15 writers struggling to keep up to 5 strategists overseeing AI-generated content. The quality is better, the consistency is flawless, and our clients have never been happier.',
      name: 'Arun Nair',
      role: 'Marketing Director, BrandVista Agency',
    },
    techStack: ['Python', 'OpenAI API', 'FastAPI', 'React', 'PostgreSQL', 'Celery', 'Redis'],
    tags: ['AI', 'Marketing', 'Automation', 'Content Generation'],
  },
  {
    id: 5,
    slug: 'finsecure-payment-platform',
    title: 'Building a PCI-DSS Level 1 Payment Gateway Processing 1M+ Daily Transactions',
    client: 'FinSecure Technologies',
    industry: 'Fintech',
    service: 'custom-software',
    duration: '12 Months',
    team: '22 Members',
    image: 'https://readdy.ai/api/search-image?query=Financial%20technology%20dashboard%20on%20screens%20showing%20real-time%20payment%20transaction%20data%20and%20security%20metrics%2C%20dark%20theme%20with%20gold%20and%20teal%20accents%2C%20server%20room%20with%20blinking%20lights%2C%20secure%20banking%20environment%2C%20high%20detail%20fintech%20photography&width=1200&height=700&seq=cs-finsecure&orientation=landscape',
    challenge: 'FinSecure needed to build a payment gateway from scratch that could handle 1M+ daily transactions across multiple payment methods (UPI, cards, net banking, wallets) while maintaining PCI-DSS Level 1 compliance. The system needed 99.99% uptime because even 5 minutes of downtime would cost crores in failed transactions.',
    approach: 'We built the core transaction engine in Go for maximum throughput, used PostgreSQL with read replicas for transactional data, Redis for caching, and Kafka for event streaming. The fraud detection system used ML models trained on 10M+ historical transactions. The entire infrastructure was deployed on Kubernetes for auto-scaling and zero-downtime deployments.',
    solution: [
      'High-throughput transaction engine in Go handling 10K TPS peak',
      'Multi-payment method integration (UPI, cards, net banking, wallets)',
      'ML-powered fraud detection with 99.8% accuracy, < 0.1% false positives',
      'PCI-DSS Level 1 compliant architecture with HSM integration',
      'Real-time settlement engine with automated reconciliation',
      'Multi-currency support across 50+ currencies',
      'Developer-friendly APIs with comprehensive SDKs',
      'Operational dashboard with real-time monitoring and alerts',
    ],
    results: [
      { value: '1M+', label: 'Daily Transactions' },
      { value: '99.97%', label: 'Uptime Since Launch' },
      { value: '10K TPS', label: 'Peak Throughput' },
      { value: '99.8%', label: 'Fraud Detection Rate' },
      { value: '50+', label: 'Currencies Supported' },
    ],
    testimonial: {
      quote: 'This payment gateway is the backbone of our business. The architecture they designed handles our peak Diwali traffic — 5x normal volume — without breaking a sweat. The fraud detection alone has saved us crores.',
      name: 'Rohit Bansal',
      role: 'CTO, FinSecure Technologies',
    },
    techStack: ['Go', 'PostgreSQL', 'Redis', 'Kafka', 'Kubernetes', 'AWS', 'TensorFlow'],
    tags: ['Fintech', 'Payments', 'Security', 'High Scale'],
  },
  {
    id: 6,
    slug: 'edulearn-gamified-platform',
    title: 'How EduLearn Got 50K Students Hooked on Learning with Gamification',
    client: 'EduLearn Academy',
    industry: 'Education',
    service: 'mobile-app-development',
    duration: '7 Months',
    team: '10 Members',
    image: 'https://readdy.ai/api/search-image?query=Educational%20mobile%20app%20on%20tablet%20showing%20colorful%20gamified%20learning%20interface%20with%20progress%20badges%2C%20children%20learning%20in%20bright%20classroom%2C%20interactive%20quiz%20screens%2C%20warm%20natural%20light%2C%20modern%20EdTech%20environment%2C%20high%20detail%20photography&width=1200&height=700&seq=cs-edulearn&orientation=landscape',
    challenge: 'EduLearn had great course content but struggled with student engagement — only 35% of enrolled students completed courses. The existing web-only platform was clunky on mobile, and the one-size-fits-all approach meant advanced students were bored while struggling students fell behind. They needed mobile-first with personalization.',
    approach: 'We built a Flutter cross-platform app with gamification at its core — XP points, leaderboards, streaks, and achievement badges. An AI tutor chatbot using GPT was integrated for instant doubt resolution. The adaptive learning engine adjusted difficulty based on student performance. Offline mode was critical since many students had intermittent internet.',
    solution: [
      'Flutter app for iOS and Android with identical feature parity',
      'Gamification system with XP, levels, badges, and leaderboards',
      'AI tutor chatbot providing instant answers to student questions',
      'Adaptive learning engine personalizing difficulty per student',
      'Live class streaming with interactive quizzes and polls',
      'Offline content downloads with automatic sync when online',
      'Parent dashboard with detailed progress analytics',
    ],
    results: [
      { value: '92%', label: 'Course Completion Rate (was 35%)' },
      { value: '50K+', label: 'Active Students' },
      { value: '4.8/5', label: 'App Store Rating' },
      { value: '45 mins', label: 'Avg. Daily Learning Time' },
      { value: '78%', label: 'Student Retention Rate' },
    ],
    testimonial: {
      quote: 'Seeing students voluntarily spending 45 minutes a day on our app — even on weekends — tells you everything. The gamification hooked them, but the quality content kept them. Best investment in our 10-year history.',
      name: 'Deepa Krishnan',
      role: 'Principal, EduLearn Academy',
    },
    techStack: ['Flutter', 'Node.js', 'MongoDB', 'WebRTC', 'Firebase', 'OpenAI API'],
    tags: ['EdTech', 'Mobile', 'Gamification', 'AI'],
  },
];